require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconProject.tsx
var IconProject_exports = {};
__export(IconProject_exports, {
  default: () => IconProject_default
});
module.exports = __toCommonJS(IconProject_exports);

// src/assets/monochrome/project.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgProject = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.6 2.8C3.60589 2.8 2.8 3.60589 2.8 4.6V15.4C2.8 16.3941 3.60589 17.2 4.6 17.2H15.4C16.3941 17.2 17.2 16.3941 17.2 15.4V9.37C17.2 8.87294 17.6029 8.47 18.1 8.47C18.5971 8.47 19 8.87294 19 9.37V15.4C19 17.3882 17.3882 19 15.4 19H4.6C2.61178 19 1 17.3882 1 15.4V4.6C1 2.61178 2.61177 1 4.6 1H11.35C11.8471 1 12.25 1.40294 12.25 1.9C12.25 2.39706 11.8471 2.8 11.35 2.8H4.6Z", fill: "#676F7E" }),
  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.2355 1.64475C16.0979 0.783845 17.4948 0.785291 18.3554 1.64785C18.7665 2.05988 18.9982 2.61775 19 3.1999C19.0015 3.78642 18.7688 4.34985 18.3535 4.76409C18.3534 4.76418 18.3536 4.76399 18.3535 4.76409L10.344 12.7756C10.2543 12.8653 10.1451 12.9328 10.0249 12.973L7.07619 13.9579C6.78248 14.056 6.45857 13.9796 6.23956 13.7607C6.02055 13.5417 5.94404 13.2178 6.04196 12.924L7.02391 9.97737C7.06405 9.85691 7.13168 9.74747 7.22146 9.65771L15.2355 1.64475ZM16.3902 2.80201C16.3902 2.8021 16.3903 2.80193 16.3902 2.80201L8.51359 10.6776L8.10992 11.8889L9.32439 11.4832L17.1992 3.60647C17.3058 3.50018 17.3657 3.35556 17.3654 3.20486C17.3649 3.05408 17.3049 2.90958 17.1984 2.80283M16.3902 2.80201C16.6136 2.57929 16.9756 2.57948 17.1984 2.80283L16.3902 2.80201Z", fill: "#676F7E" })
] });
var project_default = SvgProject;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconProject.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconProject = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(project_default, {}) });
};
IconProject.displayName = "IconProject";
var IconProject_default = IconProject;
